/*
 * @Author: Jiajia Li
 * @Date: 2024-08-31 11:59:02
 * @LastEditTime: 2024-10-01 11:09:06
 * @Description:
 */
import React, { useLayoutEffect } from "react";
import { useLoaderData } from "react-router-dom";
import api from "../components/api";
import ProductItem from "../components/ProductItem";
import "./BrandProducts.css";

export const BrandProductLoader = async ({ params }) => {
  const response = await api.get("/brands/" + params.brand);
  return await response.data;
};

export default function BrandProducts() {
  const brand = useLoaderData();
  const productCount = brand.products.length;

    // Add this useEffect hook
    useLayoutEffect(() => {
      window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant'
        });
      }, []);
  
  
  return (
    <div className="brand w-100">
      <div className="card py-4">
        <div className="row align-items-center">
          {brand.image && (
            <div className="col text-end">
              <img
                src={brand.image}
                className="card-img-top brand-img"
                alt="..."
              />
            </div>
          )}
          <div className="col">
            <div className={`card-body${!brand.image && ' text-center'}`}>
              <h5 className="card-title">{brand.name}</h5>
              <p className="card-text">
                {productCount} {productCount <= 1 ? "product" : "products"}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="product-grid-view w-100">
        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 row-cols-xl-5 g-4 mt-3">
          {brand.products.map((item) => (
            <div key={item.id} className="col">
              <ProductItem item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
